import compose from 'recompose/compose';
import formatPrismicData from '../../hocs/formatPrismicData';
import { pickMediaQueries } from 'src/client/js/view/hocs/withMediaQueries';
import OffersCarousel from './OffersCarousel';
import mapProps from 'recompose/mapProps';
import withCountry from '../../hocs/withCountry';
import { localiseUrl } from '../../../../../common/utils/format-localised-url';

const enhance = compose(
  formatPrismicData,
  withCountry,
  pickMediaQueries(['fabletDown']),
  mapProps(props => ({
    ...props,
    items: props.items.map(item => item.offerDocument),
    ctaLink: localiseUrl(props.country, props.ctaLink),
  }))
);

export default enhance(OffersCarousel);



// WEBPACK FOOTER //
// ./src/client/js/view/components/OffersCarousel/index.js